import React, { useState } from "react";
import {
  LanguageSelectContainer,
  LanguageButton,
  LanguageDropdown,
  LanguageOption,
} from "./LanguageSelect.style";
import { useApp } from "../../context/AppContext";
import { ChevronDownIcon, CheckIcon } from "../icons";

const LanguageSelect = () => {
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const { colors, isRTL, isDark, toggleTheme, setLanguage, language } =
    useApp();

  const handleLanguageChange = (language) => {
    setLanguage(language);
    setLangDropdownOpen(false);
  };

  const translations = {
    he: {
      hebrew: "עברית",
      english: "אנגלית",
    },
    en: {
      hebrew: "Hebrew",
      english: "English",
    },
  };

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  return (
    <LanguageSelectContainer>
      <LanguageButton
        $colors={colors}
        onClick={() => setLangDropdownOpen(!langDropdownOpen)}
      >
        <span>{t(language === "he" ? "hebrew" : "english")}</span>
        <ChevronDownIcon />
      </LanguageButton>
      {langDropdownOpen && (
        <LanguageDropdown $colors={colors}>
          <LanguageOption
            $colors={colors}
            $active={language === "he"}
            onClick={() => handleLanguageChange("he")}
          >
            <span className="flag">🇮🇱</span>
            {t("he")}
            {language === "he" && (
              <CheckIcon
                style={{
                  marginInlineStart: "auto",
                  color: colors.accent,
                  width: 14,
                  height: 14,
                }}
              />
            )}
          </LanguageOption>
          <LanguageOption
            $colors={colors}
            $active={language === "en"}
            onClick={() => handleLanguageChange("en")}
          >
            <span className="flag">🇺🇸</span>
            {t("en")}
            {language === "en" && (
              <CheckIcon
                style={{
                  marginInlineStart: "auto",
                  color: colors.accent,
                  width: 14,
                  height: 14,
                }}
              />
            )}
          </LanguageOption>
        </LanguageDropdown>
      )}
    </LanguageSelectContainer>
  );
};

export default LanguageSelect;
